import icons from 'constants/productCategories';
export default (icon) => icons()[icon] || icons().empty;
